import 'jquery-validation/dist/jquery.validate.min';
import 'jquery-validation/dist/additional-methods.min';
import { module } from 'modujs';

export default class extends module {
  constructor(m) {
    super(m);
    this.events = {
      click: {
        submitAjax: 'submitAjax',
        submit: 'submit',
      },
      change: {
        isWeekend: 'isWeekend',
        checkParent: 'checkParent',
        checkVisibility: 'checkVisibility',
      },
    };

    this.ajaxurl = '/wp/wp-admin/admin-ajax.php';
  }

  updateVisibilities() {
    const showWith = $(`[data-showwithfield]`);

    $.each(showWith, function (indexInArray, elmt) { 
      let val = $(`${$(elmt).data('showwithfield')}`).val();
      if ($(elmt).data('showwithvalue') === val) {
        $(elmt).show();
      }
      else {
        $(elmt).hide();
      }
    });
  }

  init() {
    if (this.getData("checkleave")) {
      $(window).bind('beforeunload', function () {
        if (
          $('.c-form_msg').hasClass('success') ||
          (!$.trim($('#fin_appel').val()) && !$.trim($('#debut_appel').val()))
        ) {
          return void 0;
        }
        return true;
      });
    }

    $(`[data-showwithfield] input[value='']`).parent('[data-showwithfield]').hide();

    this.updateVisibilities();
  }

  isWeekend(e) {
    const target = e.currentTarget;
    if ($(target).val()) {
      let val = $(target).val();
      let date = new Date(val);
  
      var dayOfWeek = date.getDay();
      var isWeekend = dayOfWeek === 6 || dayOfWeek === 0;
      $('#ferie').prop('checked', isWeekend);
    }
  }

  checkParent(e) {
    const target = e.currentTarget;
    if ($(target).val()) {
      let val = $(target).prop("checked");
      let parent = $(target).data('parent');
      
      if (val) {
        $(`#${parent}`).prop('checked', true);
      }
      else if (!$(`[data-parent=${parent}]:checked`).length) {
        $(`#${parent}`).prop('checked', false);
      }
    }
  }

  checkVisibility(e) {
    const target = e.currentTarget;
    const targetId = $(target).attr('id');
    let val = $(target).val();

    const showWith = $(`[data-showwithfield='#${targetId}']`);
    if (val && showWith.length) {
      if (showWith.data('showwithvalue') === val) {
        $(showWith).show();
      }
      else {
        $(showWith).hide();
      }
    }
    else if (showWith.length) {
      $(showWith).hide();
    }
  }

  // showField(e) {
  //   const target = e.currentTarget;
  //   $(target)
  //     .find('input:checked')
  //     .each(function () {
  //       if ($(this).data('show')) {
  //         $($(this).data('show')).show();
  //         $($(this).data('show')).next('.error').show();
  //         $(this).addClass("active");
  //         $(this).removeClass('inactive');
  //       }
  //     });

  //   $(target)
  //     .find('input:not(:checked).active')
  //     .each(function () {
  //       $($(this).data('show')).hide();
  //       $($(this).data('show')).next('.error').hide();
  //       $(this).removeClass('active');
  //       $(this).addClass('inactive');
  //     });
  // }

  submitAjax(e) {
    const target = e.currentTarget;
    var form = jQuery(target).parents('form');

    this.checkForm(form);

    if (form.valid()) {
      var data = new FormData(form[0]);
      $.ajax({
        url: this.ajaxurl,
        type: 'POST',
        data: data,
        processData: false,
        contentType: false,
        success: function (response) {
          if (response.redirectto) {
            if (response.redirectWait) {
              let remain = response.redirectWait / 1000;
              
              var interval = setInterval(function () {
                form.find('.c-form_msg .redirect').remove();
                if (remain > 1) {
                  form.find('.c-form_msg').append("<div class='redirect'>Vous allez être redirigé(e) dans " + remain + " secondes</div>");
                }
                else {
                  form.find('.c-form_msg').append("<div class='redirect'>Vous allez être redirigé(e) dans " + remain + " seconde</div>");
                }
                remain--;
                if (remain <= 0) {
                  remain=0;
                  clearInterval(interval);
                  window.location.href = response.redirectto;
                }
              }, 1000);
            }
            else {
              window.location.href = response.redirectto;
            }
          }
          form.find('.c-form_msg').addClass('u-margin-top-small');
          if (response.msg) {
            form.find('.c-form_msg').html(response.msg).fadeIn(1000);
          }
          if (response.status == 'success') {
            form.find('.c-form_msg').removeClass('error');
            form.find('.c-form_msg').addClass('success');
            if (response.reset) {
              form[0].reset();
            }

            if (response.modal_content) {
              $('.c-modal').find('.c-modal_wrap').html(response.modal_content);
              $this.call('softOpen', false, 'Modal');
            }
            if (response.modal) {
              $this.call('close', false, 'Modal'); // update Locomotive Scroll
            }
          } else {
            form.find('.c-form_msg').removeClass('success');
            form.find('.c-form_msg').addClass('error');
          }
        },
        complete: function () {
          form.find('.c-form_action .c-button').show();
        },
      });
    } else {
      form.find('.c-form_msg').addClass('u-margin-top-small');
      form
        .find('.c-form_msg')
        .html('<p>Oops! Veuillez remplir les champs.</p>')
        .fadeIn(1000);
      form.find('.c-form_msg').removeClass('success');
      form.find('.c-form_msg').addClass('error');
    }
  }

  submit(e) {
    const target = e.currentTarget;
    var form = jQuery(target).parents('form');

    this.checkForm(form);

    if (form.valid()) {
      form.submit();
    } else {
      form.find('.c-form_msg').addClass('u-margin-top-small');
      form
        .find('.c-form_msg')
        .html('<p>Oups! Veuillez remplir les champs.</p>')
        .fadeIn(1000);
      form.find('.c-form_msg').removeClass('success');
      form.find('.c-form_msg').addClass('error');
    }
  }

  checkForm(form) {
    var $ = jQuery;
    var $msg_error = 'Ce champ est obligatoire';
    var $msg_error_email =
      'Saisir une adresse email valide (ex: email@exemple.com)';
    var $msg_error_nombre =
      'Saisir un nombre valide';
    var $msg_error_extension =
      'Types de fichiers autorisés .pdf, .jpg, .jpeg, .png, .docx, .doc, .odt';
    var $msg_error_filesize =
      'Fichier trop volumineux, la taille maximale autorisée est de 5Mo';
    var $msg_error_password =
      'Le mot de passe doit être identique';

    $.validator.addMethod(
      'filesize',
      function (value, element, param) {
        return this.optional(element) || element.files[0].size <= param;
      },
      $msg_error_filesize
    );

    $(form).validate({
      ignore: [],
      lang: 'fr',
      errorElement: 'div',
      errorPlacement: function (error, element) {
        var placement = $(element).data('error');
        if (placement) {
          $(placement).append(error);
        } else {
          error.insertAfter(element);
        }
      },
    });
    const required = document.querySelectorAll(`[data-required]`);

    const rules = [];
    required.forEach(function (element) {
      if (!$(element).parents('.is-hidden').length) {
        $(element).rules('add', {
          required: true,
          messages: { required: $msg_error },
        });
        if ($(element).attr('type') == 'email') {
          $(element).rules('add', {
            email: true,
            messages: { email: $msg_error_email },
          });
        } else if ($(element).attr('type') == 'file') {
          $(element).rules('add', {
            extension: 'jpeg|jpg|png|pdf|docx|doc|odt',
            filesize: 5242880,
            messages: { extension: $msg_error_extension },
          });
        } else if ($(element).attr('type') == 'number') {
          $(element).rules('add', {
            number: true,
            messages: { number: $msg_error_nombre },
          });
        } else if ($(element).attr('type') == 'password' && $(element).attr('id') == 'confirm_password') {
          $(element).rules('add', {
            equalTo: "#password",
            messages: { equalTo: $msg_error_password },
          });
        }
      }
    });

    const files = this.$('file');
    files.forEach(function (element) {
      if ($(element).attr('type') == 'file') {
        $(element).rules('add', {
          extension: 'jpeg|jpg|png|pdf|docx|doc|odt',
          filesize: 5242880,
          messages: { extension: $msg_error_extension },
        });
      }
    });

    const requiredWith = this.$('requiredWith');
    requiredWith.forEach(function (element) {
      if (!$(element).parents('.is-hidden').length) {
        $(element).rules('add', {
          required: function (element) {
            const linkedInput = $(element).data('required_with');
            console.log($(`${linkedInput}`), $(`${linkedInput}`).is(':checked'));
            return $(`${linkedInput}`).is(':checked');
          },
          messages: { required: $msg_error },
        });
      }
    });
  }
}
